<template>
    <div id="backStandard">
        <my-header></my-header>
        <div class="banner">
            <img src="../../../assets/images/backStandard/topBg.jpg"/>
            <div class="main-container">
                <div class="bannerText">
                    <h2>{{ projectName }}<span>{{ getRounds() }}</span></h2>
                    <p>{{ getRounds() }}截止时间：{{ endTime }}</p>
                </div>
            </div>
        </div>

        <div class="main-container mainWrap">
            <div class="small-container titleWrap">
                <el-menu default-active="1" class="el-menu-demo" mode="horizontal">
                    <el-menu-item index="1">{{ getSn() }}</el-menu-item>
                </el-menu>
            </div>
            <section class="small-container downLoadWrap" v-if="rounds == 2 && bidFile.attachName">
                <div class="downBtn">
                    <span>二轮标书下载：</span>
                    <a href="javascript:;" @click="fileListHandleDownload()" title="点击下载" class="fileName"><i class="el-icon-document"></i>{{ bidFile.attachName }}</a>
                </div>
            </section>
            <!--商务谈判查看-->
            <section class="small-container" v-if="actionStatus == '8' && !isEdit">
                <h3>回标历史</h3>
                <el-table :data="extWFlowFormBackBidRoundList" border highlight-current-row style="width: 100%">
                    <el-table-column label="轮次" align="center">
                        <template slot-scope="scope">
                            <span>第{{scope.row.round}}轮</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="标段" align="center">
                        <template slot-scope="scope">
                            <span>标段{{sn}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="回标时间" align="center">
                        <template slot-scope="scope">
                            <span>{{scope.row.businessNegotiationTime}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="商务谈判报价(含税)" align="center">
                        <template slot-scope="scope">
                            <span>{{scope.row.businessNegotiationWithTax}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="商务谈判报价进项税" align="center">
                        <template slot-scope="scope">
                            <span>{{scope.row.businessNegotiationInputTax}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="商务谈判附件" align="center">
                        <template slot-scope="scope">
                            <a class="words" href="javascript:;" v-if="scope.row.roundBusinessAttachmentUrl"
                               @click="fileListHandleDownload(scope.row.roundBusinessAttachmentName,scope.row.roundBusinessAttachmentUrl)"
                               title="点击下载">
                                {{ scope.row.roundBusinessAttachmentName}}
                            </a>
                        </template>
                    </el-table-column>
                </el-table>
            </section>
            <!--商务谈判回标-->
            <section class="small-container" v-else>
                <p><span class="tips" style="color: #cb1235;">上传附件大小不要超过500M</span></p>
                <h3>商务标<span class="tips" style="margin-left: 30px;">请确认价格输入准确！</span></h3>
                <el-form
                    label-position="left"
                    :model="commerceForm"
                    :rules="commerceRules"
                    status-icon
                    ref="commerceForm"
                    label-width="180px"
                    class="commerceForm">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="报价（含税，元）：" prop="priceWithTax">
                                <el-input v-model="commerceForm.priceWithTax" :maxlength="20"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="进项税（元）：" prop="priceInInputTax" >
                                <el-input v-model="commerceForm.priceInInputTax" :maxlength="20"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="商务标附件：" required class="uploadItem">
                                <page-upload :files="commerceForm.business"
                                             class="uploadFloat"
                                             v-on:finishUpload="finishUploadFile"
                                             :editFlag="true"
                                             attachmentType=""
                                             :limitType="2"
                                             :isIconTable="2"
                                             :notMany="true"
                                             :disable="isEdit ? '' : 1"
                                            ></page-upload>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </section>
            <section class="small-container" v-if="rounds == 1">
                <h3>技术标</h3>
                <el-form
                    label-position="left"
                    :model="technologyForm"
                    :rules="technologyRules"
                    status-icon
                    ref="technologyForm"
                    label-width="180px"
                    class="technologyForm">
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="技术标附件：" required class="tipIcon">
                                <strong>明标</strong>
                                <page-upload :files="technologyForm.bright"
                                             class="uploadFloat"
                                             v-on:finishUpload="finishUploadBrightFile"
                                             :editFlag="true"
                                             attachmentType=""
                                             :limitType="2"
                                            :isIconTable="2"
                                             :notMany="true"
                                            :disable="isEdit ? '' : 1"></page-upload>
                                <!--:notViewList="true"-->
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="技术标附件：" required class="tipIcon" >
                                <strong>暗标</strong>
                                <page-upload :files="technologyForm.dark"
                                             class="uploadFloat"
                                             v-on:finishUpload="finishUploadDarkFile"
                                             :editFlag="true"
                                             attachmentType=""
                                             :limitType="2"
                                             :isIconTable="2"
                                             :disable="isEdit ? '' : 1"
                                             :notMany="true"></page-upload>
                                <!--:notViewList="true"-->
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </section>
            <div style="margin: 40px 0 0;"  v-if="isEdit">
                <el-button class="cancelBtn" style="padding: 10px 40px;font-size: 14px;background: #cfcfcf;" @click="cancel" >取消</el-button>
                <el-button type="primary" style="padding: 10px 40px;font-size: 14px;" @click="submit">提交</el-button>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'backStandard',
        data() {
           var checkFile = function(rule,value,callback){
                if(value.length){
                    callback();
                } else {
                    callback(new Error('附件不能为空'))
                }
            };
            return {
                formId: '',//当前跳转的路由id
                cancelId: '',//点击取消时的路由id
                sn: 1,//当前是标段几；
                rounds:1,//当前是回标1 二轮回标2 商务谈判3 评标约谈4；
                isEdit: true,//是否可以上传
                projectName: '',//项目名称
                endTime: '',//截止时间
                actionStatus: 2,//当前是回标 2 还是 二轮 6，商务谈判 8 ，评标约谈 10
                bidFile: {//下载标书文件
                    attachName: '',
                },
                commerceForm: {//商务标
                    priceInInputTax: '',//进项税
                    priceWithTax: '',//报价
                    business: []//商务标附件
                },
                commerceRules: {
                    priceInInputTax: [
                        { required: true, message: '进项税不能为空'},
                        { validator: this.checkDeg,trigger: 'blur' }
                    ],
                    priceWithTax: [
                        { required: true, message: '报价不能为空'},
                        { validator: this.checkDeg,trigger: 'blur' }
                    ],
                    business: [
                        { required: true,validator: checkFile ,trigger:'change'}
                    ],
                },
                technologyForm: {//技术标
                    bright: [],
                    dark: []
                },
                technologyRules: {
                    bright: [
                        { required: true,validator: checkFile ,trigger:'change' }
                    ],
                    dark: [
                        { required: true,validator: checkFile ,trigger:'change' }
                    ],
                },
                extWFlowFormBackBidRoundList: []
            }
        },
        created(){
            this.$root.activeIndex = 'win';
            if(this.$route.params.entrance == 1){//entrance 1 代表从标段的title按钮进入的，可上传 提交
                this.isEdit = true;
            } else {//entrance 2 代表从垂直的历史进度条进入的，不可上传 提交
                this.isEdit = false;
            }
            this.actionStatus = this.$route.params.status;
            let obj = JSON.parse(window.sessionStorage.getItem('backStandardData'));
            this.formId = obj.dealBisVo.flowFormExtMng.flowFormId;
            this.cancelId = obj.dealBisVo.flowFormExtMng.id;
            this.projectName = obj.dealBisVo.flowFormExtMng.formTitle;
            this.endTime = obj.endTime;
            this.commerceForm.priceInInputTax = obj.businessBidVo.priceInInputTax;
            this.commerceForm.priceWithTax = obj.businessBidVo.priceWithTax;
            obj.sendBidTwoSattach && (this.bidFile = obj.sendBidTwoSattach);
            this.sn = obj.sn;
            this.rounds = obj.rounds;
            obj.businessBidVo.business && this.commerceForm.business.push(obj.businessBidVo.business);
            if(obj.technologyBidVo){
                obj.technologyBidVo.bright && this.technologyForm.bright.push(obj.technologyBidVo.bright);
                obj.technologyBidVo.dark && this.technologyForm.dark.push(obj.technologyBidVo.dark);
            }
            if(obj.rounds == 2){
                this.getList();//初始化下载标书的列表；
            }
            /*商务谈判历史*/
            if(!this.isEdit && this.actionStatus == '8'){
                this.extWFlowFormBackBidRoundList = obj.extWFlowFormBackBidRoundList || [];
            }
        },
        methods: {
            checkDeg(rule,value,callback){
                // let reg = /^(-?\d+)(\.\d+)?$/;
                let reg = /^\d+(\.\d{1,2})?$/;
                if(!reg.test(value)) {
                    callback(new Error('请输入数字，且小数点后不超过两位'));
                } else {
                    callback();
                }
            },
            getSn(){
                if(this.sn == 1){
                    return '标段一'
                } else if(this.sn == 2){
                    return '标段二'
                } else if(this.sn == 3){
                    return '标段三'
                }
            },
            getRounds(){
                if(this.rounds == 1){
                    return '回标';
                } else if(this.rounds == 2){
                    return '二轮回标';
                } else if(this.rounds == 3){
                    return '商务谈判';
                } else if(this.rounds == 4){
                    return '评标约谈';
                }
            },
            getList(){
                let that = this;
                this.$root.postHttp('/v1/outerformflow/bidFile/list',{
                    formId: this.$route.params.formId,
                    type: 2//第一次发标文件 1，二轮发标文件 2 ,不写默认查出所有
                },function (res) {
                    that.tableData = res.data.data.attachments;
                })
            },
            getNodeName(){
                if(this.$route.params.status == 2 || this.$route.params.status == 3){
                    return '回标';
                } else if(this.$route.params.status == 6 || this.$route.params.status == 7){
                    return '二轮回标';
                } else if(this.$route.params.status == 8 || this.$route.params.status == 9){
                    return '商务谈判';
                } else if(this.$route.params.status == 10 || this.$route.params.status == 11){
                    return '评标约谈';
                }
            },
            fileListHandleDownload(attachName,attachPath) {
                let that = this;
                that.$confirm('确定下载该附件吗?',{
                    type:'warning',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then( () => {
                    that.$root.downloadFile({
                        attachName: attachName ? attachName : that.bidFile.attachName,
                        attachPath: attachPath ? attachPath : that.bidFile.attachPath
                    });
                }).catch(() => {
                    that.$message({
                        type: 'info',
                        message: '已取消下载'
                    })
                });
            },
            finishUploadFile(val){//文件上传完成后，同步商务标的数据；
                if(val.fileList.length){
                    if(this.commerceForm.business.length){
                        this.commerceForm.business[0].attachName = val.fileList[0].attachName;
                        this.commerceForm.business[0].attachPath = val.fileList[0].attachPath;
                    } else {
                        this.commerceForm.business[0]= {
                            attachName: val.fileList[0].attachName,
                            attachPath: val.fileList[0].attachPath
                        };
                    }

                }
            },
            finishUploadBrightFile(val){//文件上传完成后，同步技术标明标的数据；
                if(val.fileList.length){
                    if(this.technologyForm.bright.length){
                        this.technologyForm.bright[0].attachName = val.fileList[0].attachName;
                        this.technologyForm.bright[0].attachPath = val.fileList[0].attachPath;
                    } else {
                        this.technologyForm.bright[0] = {
                            attachName: val.fileList[0].attachName,
                            attachPath: val.fileList[0].attachPath
                        };
                    }
                }
            },
            finishUploadDarkFile(val){//文件上传完成后，同步技术标暗标的数据；
                if(val.fileList.length){
                    if(this.technologyForm.dark.length){
                        this.technologyForm.dark[0].attachName = val.fileList[0].attachName;
                        this.technologyForm.dark[0].attachPath = val.fileList[0].attachPath;
                    } else {
                        this.technologyForm.dark[0] = {
                            attachName: val.fileList[0].attachName,
                            attachPath: val.fileList[0].attachPath
                        };
                    }
                }
            },
            submitForm(){
                let that = this;
                let obj = {
                    formId: that.$route.params.formId,
                    subId: that.$route.params.id,
                    businessBidVo: {
                        priceInInputTax: that.commerceForm.priceInInputTax,
                        priceWithTax: that.commerceForm.priceWithTax,
                        business: that.commerceForm.business[0]
                    },
                    technologyBidVo: {
                        bright: that.technologyForm.bright[0],
                        dark: that.technologyForm.dark[0],
                    }
                };
                if(!obj.businessBidVo.business) {
                    that.$alert('带*的附件必须上传', '提示', {
                        confirmButtonText: '确定',
                        type: 'warning'
                    });
                    return;
                }
                if(that.actionStatus != 2 ){
                    obj.technologyBidVo = null;
                } else {
                    if(!obj.technologyBidVo.bright || !obj.technologyBidVo.dark){
                        that.$alert('带*的附件必须上传', '提示', {
                            confirmButtonText: '确定',
                            type: 'warning'
                        });
                        return;
                    }
                }
                that.$root.postHttp('/v1/outerformflow/backBid/submit',obj,function (res) {
                    that.$message.success('提交成功');
                    setTimeout( () => {
                        that.$router.push('/master/processManagement/'+that.formId);
                    },1000)
                })
            },
            submit(){
                let that = this;
//                that.submitForm();
                this.$refs.commerceForm.validate((valid) => {
                    if (valid) {
                        if(that.actionStatus != 2){
                            that.submitForm();
                            return;
                        }
                        that.$refs.technologyForm.validate((valid2) => {
                            if(valid2){
                                that.submitForm();
                            } else {
                                that.$alert('请把带*的必填字段填写完整', '提示', {
                                    confirmButtonText: '确定',
                                    type: 'warning'
                                });
                            }
                        })
                    } else {
                        that.$alert('请把带*的必填字段填写完整', '提示', {
                            confirmButtonText: '确定',
                            type: 'warning'
                        });
                        return false;
                    }
                });
            },
            cancel(){//取消提交
                this.$router.push('/master/processManagement/'+this.cancelId);
            }
        }
    }
</script>
<style lang="scss">
@import "../../../assets/var";
#backStandard {
    padding-bottom: 50px;
    background: $--primary-fill-color;
    & .head-top{
        background: #fff;
    }
    & .head-right {
        color: $--text-color-light;
        & .login {
            background: url('../../../assets/images/topBar2/icon07.png') no-repeat 0 1px;
        }
        & .register {
            background: url('../../../assets/images/topBar2/icon08.png') no-repeat 0 1px;
        }
        & .line {
            background: $--text-color-light;
        }
        & .help {
            background: url('../../../assets/images/topBar2/icon05.png') no-repeat;
        }
        & .wechat {
            background: url('../../../assets/images/topBar2/icon06.png') no-repeat;
        }
    }
    .banner {
        margin-top: 80px;
        img {
            width: 100%;
        }
        .main-container {
            position: relative;
            .bannerText {
                position: absolute;
                left: 0;
                top: -50px;
                width: 100%;
                color: #fff;
                line-height: 34px;
                h2 {
                    float: left;
                    font-size: 18px;
                    span {
                        display: inline-block;
                        vertical-align: middle;
                        border: 1px solid #fff;
                        padding: 0 8px;
                        margin-left: 15px;
                        height: 24px;
                        font-size: 14px;
                        line-height: 22px;
                        border-radius: 4px;
                        font-weight: normal;
                        box-sizing: border-box;
                    }
                }
                p {
                    float: right;
                    font-size: 14px;
                }
            }
        }
    }
    .mainWrap {
        position: relative;
        margin-top: 40px;
        padding-bottom: 60px;
        background: #fff;
    }
    .small-container {
        width: 1120px;
        margin: 0 auto;
        padding-top: 15px;
        & form {
              width: 95%;
              margin: 15px auto;
            .el-form-item {
                color: #333;
            }
            & .el-form-item__label {
                  padding: 0 22px 0 0;
                    color: #333;
              }
            & .el-form-item__content {
                  width: 56%;
                  text-align: left;
                & .el-select {
                      /*width: 35%;*/
                  }
            }
        }
        .technologyForm {
            .el-form-item__error {
                left: 150px;
            }
        }
        & h3,
        & h4{
              padding: 0 30px;
              text-align: left;
              line-height: 50px;
              color: $--text-color-light;
              background: $--secondary-fill-color;
              overflow: hidden;
          }
        & h4 {
              text-indent: 10px;
              line-height: 35px;
              background: $--primary-fill-color;
          }
        &>p{
             text-align: right;
             margin-bottom: 10px;
         }
        & .tips {
              padding-left: 20px;
              font-weight: normal;
              font-size: 12px;
              color: $--text-color-light;
              background: url('../../../assets/images/register/icon03.png') no-repeat left center;
          }
        & .uploadItem {
            .el-form-item__content {
                width: 914px;
            }
        }
        & .tipIcon {
              position: relative;
            .el-form-item__content {
                position: static;
                width: 914px;
            }
            & strong {
              position: absolute;
              display: inline-block;
              border: 1px solid #000;
              background: #000;
              color: #fff;
              border-radius: 3px;
              font-weight: normal;
              line-height: 20px;
              padding: 0 5px;
              left: 95px;
              top: 9px;
          }
        }
    }
    .titleWrap {
        text-align: left;
    }
    .downLoadWrap {
        padding-top: 40px;
        text-align: left;
        font-size: 14px;
        .downBtn {
            padding: 20px 20px 0;
        }
        .fileName {
            margin-left: 30px;
            color: #333;
        }
        .fileName:hover {
            color: $--primary-color;
        }
    }
    .uploadFloat>div {
        float: left;
    }
    .file-list {
        margin-left: 50px;
    }
    .cancelBtn:hover,
    .cancelBtn:focus {
        border-color: rgb(207, 207, 207);
        color: #fff;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/master/inviteProcess/BackStandard.vue